<template>
  <div />
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'WebChat',
  computed: {
    ...mapState({
      loggedIn: ({ session }) => session.status.loggedIn,
      user: ({ session }) => session.user.business
    }),

    hasChatVisible () {
      return this.$route.meta.chat
    },

    hasNavbarVisible () {
      return this.$route.meta.menu
    }
  },
  methods: {
    botkitListener () {
      const id = this.user.legacyUserId
      const name = this.user.email
      const botkitListener = setInterval(() => {
        if (typeof Botkit === 'object') {
          clearInterval(botkitListener)
          window.Botkit.boot({ id, name })
        }
      }, 100)
    },

    chatVisibility () {
      const $oloswcdl = document.querySelector('#oloswcdl-root')
      const $oloswebchat = document.querySelector('.oloswebchat-main')

      function show () {
        if ($oloswcdl) $oloswcdl.setAttribute('style', 'display: block !important')
        if ($oloswebchat) $oloswebchat.setAttribute('style', 'display: block !important')
      }

      function hide () {
        if ($oloswcdl) $oloswcdl.setAttribute('style', 'display: none !important')
        if ($oloswebchat) $oloswebchat.setAttribute('style', 'display: none !important')
      }

      hide()

      if (this.loggedIn) {
        if (this.hasChatVisible) show()
        this.botkitListener()
      }
    },

    setChatPosition () {
      const $olosButton = document.querySelector('#oloswcdl-root .oloswebchat-main .cta-button')

      setTimeout(() => {
        if (!$olosButton) {
          return this.setChatPosition()
        }

        if (this.hasNavbarVisible) {
          $olosButton.setAttribute('style', 'bottom: 15px !important; right: 15px !important;')
          return
        }

        $olosButton.setAttribute('style', 'bottom: 50px !important; right: 15px !important;')
      }, 100)
    }
  },
  watch: {
    loggedIn () {
      this.chatVisibility()
    },

    hasChatVisible () {
      this.chatVisibility()
    },

    '$route.name' () {
      this.setChatPosition()
    }
  },
  mounted () {
    this.chatVisibility()
    this.setChatPosition()
  }
}
</script>

<style lang="scss">
#oloswcdl-root .oloswebchat-main {

  .cta-button {
    bottom: 15px !important;
    height: 45px  !important;;
    right: 15px !important;;
    width: 45px !important;;
    z-index: 1 !important;
  }
}
</style>
